const sectionCardVitalSlider02Css = `
[data-type='section-card-vital-slider-02'] * {
  box-sizing: border-box;
}

[data-type='section-card-vital-slider-02'] [data-attribute='card-container'] {
  color: var(--color-text, #000000);
}

[data-type='section-card-vital-slider-02'] [data-attribute='card-container'][data-top-padding='true'] {
  padding-top: 40px;
}

[data-type='section-card-vital-slider-02'] [data-attribute='card-container'][data-bottom-padding='true'] {
  padding-bottom: 40px;
}

[data-type='section-card-vital-slider-02'] [data-attribute='card-container'] .container-page[data-show-style='true'] {
  padding: 32px;
  border-radius: 20px;
  margin: auto;
  max-width: calc(100% - 32px);
  width: max-content;
}

[data-type='section-card-vital-slider-02'] [data-attribute='card-container'] .container-page .container {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

[data-type='section-card-vital-slider-02'] .title-card {
  margin-bottom: 30px;
}

[data-type='section-card-vital-slider-02'] .title-card h1,
[data-type='section-card-vital-slider-02'] .title-card h2,
[data-type='section-card-vital-slider-02'] .title-card h3 {
  font-size: 24px;
  line-height: 1.4;
  margin: 0 0 12px 0 !important;
}

[data-type='section-card-vital-slider-02'] .wrap-content {
  position: relative;
  width: 100%;
}

[data-type='section-card-vital-slider-02'] .wrap-content .swiper-button-next,
[data-type='section-card-vital-slider-02'] .wrap-content .swiper-button-prev {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #000000a1;
}

[data-type='section-card-vital-slider-02'] .wrap-content .swiper-button-next::after,
[data-type='section-card-vital-slider-02'] .wrap-content .swiper-button-prev::after {
  font-size: 16px;
  color: #ffffff;
  font-weight: bold;
}

[data-type='section-card-vital-slider-02'] .wrap-content .swiper-button-prev {
  left: 0;
}

[data-type='section-card-vital-slider-02'] .wrap-content .swiper-button-next {
  right: 0;
}

[data-type='section-card-vital-slider-02'] .wrap-item {
  position: relative;
  padding-top: 44px;
  padding-left: 44px;
}

[data-type='section-card-vital-slider-02'] .wrap-item:hover .content-item {
  background: var(--item-content-background-hover, #214a88);
  color: var(--item-content-text-color-hover, #ffffff);
}

[data-type='section-card-vital-slider-02'] .wrap-item:hover .wrap-img-decor {
  rotate: -4deg;
}

[data-type='section-card-vital-slider-02'] .wrap-item .wrap-img-decor {
  transition: all 0.25s ease;
  position: absolute;
  z-index: 1;
  width: calc(100% - 44px);
  height: calc(100% - 44px);
  top: 0;
  left: 0;
  border-radius: 30px;
  overflow: hidden;
}

[data-type='section-card-vital-slider-02'] .wrap-item .wrap-img-decor img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

[data-type='section-card-vital-slider-02'] .wrap-item .content-item {
  position: relative;
  z-index: 2;
  background: var(--item-content-background, #daecf0);
  color: var(--item-content-text-color, #214a88);
  padding: 40px 28px;
  transition: all 0.25s ease;
  display: flex;
  flex-direction: column;
  gap: 30px;
  justify-content: space-between;
  min-height: 510px;
  border-radius: 30px;
}

[data-type='section-card-vital-slider-02'] .wrap-item h1,
[data-type='section-card-vital-slider-02'] .wrap-item h2,
[data-type='section-card-vital-slider-02'] .wrap-item h3 {
  font-size: 24px;
  line-height: 1.4;
  margin: 0 0 12px 0 !important;
}

[data-type='section-card-vital-slider-02'] .wrap-item p {
  font-size: 16px;
  margin: 0 !important;
  line-height: 1.4;
}

@container (max-width: 768px) {
  [data-type='section-card-vital-slider-02'] [data-attribute='card-container'][data-top-padding='true'] {
    padding-top: 16px;
  }

  [data-type='section-card-vital-slider-02'] [data-attribute='card-container'][data-bottom-padding='true'] {
    padding-bottom: 16px;
  }

  [data-type='section-card-vital-slider-02'] [data-attribute='card-container'] .container-page[data-show-style='true'] {
    padding: 0;
  }

  [data-type='section-card-vital-slider-02'] .title-card h1,
  [data-type='section-card-vital-slider-02'] .title-card h2,
  [data-type='section-card-vital-slider-02'] .title-card h3 {
    font-size: 20px;
    margin: 0 0 8px 0 !important;
  }

  [data-type='section-card-vital-slider-02'] .wrap-item h1,
  [data-type='section-card-vital-slider-02'] .wrap-item h2,
  [data-type='section-card-vital-slider-02'] .wrap-item h3 {
    font-size: 20px;
    margin: 0 0 8px 0 !important;
  }

  [data-type='section-card-vital-slider-02'] .wrap-item p {
    font-size: 14px;
  }
}

@container (max-width: 640px) {
  [data-type='section-card-vital-slider-02'] .wrap-content .swiper-button-next,
  [data-type='section-card-vital-slider-02'] .wrap-content .swiper-button-prev {
    display: none;
  }
}

@container (max-width: 639px) {
  [data-type='section-card-vital-slider-02'] .title-card {
    margin-bottom: 20px;
  }

  [data-type='section-card-vital-slider-02'] .wrap-item {
    padding-top: 24px;
    padding-left: 24px;
  }

  [data-type='section-card-vital-slider-02'] .wrap-item:hover .wrap-img-decor {
    rotate: -2deg;
  }

  [data-type='section-card-vital-slider-02'] .wrap-item .wrap-img-decor {
    width: calc(100% - 24px);
    height: calc(100% - 24px);
  }

  [data-type='section-card-vital-slider-02'] .wrap-item .content-item {
    padding: 24px 16px;
    min-height: 400px;
  }
}
`;
export default sectionCardVitalSlider02Css;
